import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[formHost]',
    standalone: false
})
export class FormDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
